import { createFilterRequest } from '../../actions/fetch';
import { ActionType, ActionTypes } from '../../actions/index';
import { ISeatMatchRequestModel } from '../../classes/request-model';
import { SeatInfo } from '../../classes/seat';
import { getSelectedTicketCount } from '../../helpers/price-type-helpers';
import { IAppState } from '../../reducers/index';

export interface IFetchStateAction {
    type: ActionType;
    value?: any;
}

function requestSeatMatches(requestModel: ISeatMatchRequestModel) {
    return {
        type: ActionTypes.REQUEST_SEATS,
        value: requestModel
    }
}

function receiveSeatMatches(result) {
    return {
        type: ActionTypes.RECEIVE_SEATS,
        value: result
    }
}

function setSeatMatchCount( count: number, isOnlyADASeats: boolean, suggestedSeats: Array<SeatInfo>) {
    return {
        type: ActionTypes.SET_MATCHED_COUNT,
        value: { count: count, onlyADASeats: isOnlyADASeats, suggestedSeats: suggestedSeats }
    };
}

function updateSeatMatch(requestModel: ISeatMatchRequestModel, seatmapId: string) {
    return fetch(`${window.location.origin}/api/seating/GetSeatsAvailable`,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                itemType: requestModel.itemType,
                itemId: requestModel.itemId,
                minPrice: requestModel.minPrice,
                maxPrice: requestModel.maxPrice,
                //quantity: requestModel.seatQuantity,
                allowSeparatedSeats: requestModel.allowSeparatedSeats,
                priceTypeQuantities: requestModel.requestedPriceTypes.filter(pt => { return pt.quantity > 0 }),
                venueLevels: requestModel.selectedVenueLevels,
                selectedAllLevels: requestModel.selectedAllLevels,
                allowAisleAccessSelected: requestModel.allowAisleAccessSelected,
                additionalSeatingOptions: requestModel.additionalSeatingOptions,
                language: requestModel.language,
                invalidateCache: requestModel.invalidateCache,
                requestHash: requestModel.requestHash
            }),
            credentials: 'same-origin'
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return "ERROR";
            }
        })
        .catch(error => {
            console.error(error);
        });
}

interface SeatMatchResponse {
    seatsAvailable: number;
    onlyADASeats: boolean;
    suggestedSeats: Array<SeatInfo>;
    requestHash: string;
}

export function fetchSeatMatches(clearCache?: boolean) {
    return (dispatch, state) => {
        let currentState: IAppState = state();
        
        const seatMatchRequest = createFilterRequest(currentState, clearCache);
        if (getSelectedTicketCount(currentState.priceTypesModel) > 0) {

            dispatch(requestSeatMatches(seatMatchRequest));
            updateSeatMatch(seatMatchRequest, '').then((response: any) => {
                if (response === "ERROR") {
                    dispatch(receiveSeatMatches(currentState.appSettingsModel.filterErrorToast));
                } else {
                    const seatMatchResponse: SeatMatchResponse = response;
                    if (seatMatchResponse.seatsAvailable && isNaN(seatMatchResponse.seatsAvailable)) {
                        console.error('Seat match has returned a non-number value.');
                    }
                    if (state().seatMatchResultModel.matchFilter.requestHash === seatMatchResponse.requestHash) {
                        dispatch(handleSeatMatchResponseSuccess(seatMatchResponse));
                    }
                }
            });
        }
        else {
            dispatch(setBlankSeatMatchResponse());
        }
    }
}

export function setBlankSeatMatchResponse() {
    return (dispatch, state) => {
        dispatch(handleSeatMatchResponseSuccess({ seatsAvailable: 0, onlyADASeats: false, suggestedSeats: [], requestHash: '' }));
    }
}
export function handleSeatMatchResponseSuccess(response: SeatMatchResponse) {
    return (dispatch, state) => {
        let currentState: IAppState = state();
        dispatch(receiveSeatMatches(fetchToastText(response.seatsAvailable, currentState.appSettingsModel.filterToastThreshold, currentState.appSettingsModel.filterFoundToast)));
        dispatch(setSeatMatchCount(response.seatsAvailable, response.onlyADASeats, response.suggestedSeats));
    }
}

function fetchToastText(response, filterThreshold, filterFoundToast) {
    if ((filterThreshold == '' || !isNaN(response)) && (Number(response) <= Number(filterThreshold)))
        return response + ' ' + filterFoundToast;
    return filterThreshold + '+ ' + filterFoundToast;
}
